import { render, staticRenderFns } from "./downloadQRcode.vue?vue&type=template&id=65316aa4&scoped=true&"
import script from "./downloadQRcode.vue?vue&type=script&lang=js&"
export * from "./downloadQRcode.vue?vue&type=script&lang=js&"
import style0 from "./downloadQRcode.vue?vue&type=style&index=0&id=65316aa4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65316aa4",
  null
  
)

export default component.exports